import OfficeVisibility from './vendor/office_visibility.js'
import OfficeModel from './office_model.js'
import $ from 'jquery'

// Decouple our Office JS add-in from whatever craziness MSFT has in their big
// MS Office JS API. Events should be hooked into Backbone events and
// helper methods implementing in the shim.

export default class OfficeEvents {
  constructor (office, reason) {
    this.sync = this.sync.bind(this)
    this.getKey = this.getKey.bind(this)
    this.setKey = this.setKey.bind(this)
    this.loadKeys = this.loadKeys.bind(this)
    this.saveKeys = this.saveKeys.bind(this)
    this.bindOfficeHandler = this.bindOfficeHandler.bind(this)
    this.office = office
    this.document = office.context.document

    console.log('creating new OfficeModel')
    this.model = new OfficeModel({}, { sync: this.sync })

    // Detect visibility change with code provided by Dan Saunders
    // "reason" is provided by the office API on initialize
    // https://dev.office.com/reference/add-ins/shared/office.initialize
    this.visibilityDetector = new OfficeVisibility(reason, this.model.isPresenting)

    // Check what the current view is, to avoid state desync
    this.getActiveViewHandler = (result) => {
      if (result.status === 'succeeded') {
        // if powerpoint fails to switch modes, enable this for debugging.
        // overly verbose otherwise.
        // console.log('succeeded in setting activeView to: ')
        // console.log(result.value)
        return this.model.set('activeView', result.value)
      }
    }
    this.document.getActiveViewAsync(this.getActiveViewHandler)
    window.setInterval(() => {
      this.document.getActiveViewAsync(this.getActiveViewHandler)
    },
    2000)

    // Store the visibility state in the model
    this.visibilityDetector.onVisibilityChange((e) => {
      const visibility = e.visible ? 'visible' : 'hidden'
      return this.model.set({ visibility: visibility })
    })

    // Notify the model when PPT switches from edit to
    // presentation (read) view.
    console.log('binding office event ActiveViewChanged')
    this.bindOfficeHandler(this.office.EventType.ActiveViewChanged, {
      success: (event) => {
        // edit -> present: {"type":"activeViewChanged","activeView":"read"}
        // present -> edit: {"type":"activeViewChanged","activeView":"edit"}
        this.model.set('activeView', event.activeView)
        console.log(`[IMPORTANT] activeView set to ${event.activeView}`)
      },
      error (asyncResult) {
        throw new Error('Microsoft Office ActiveViewChanged Error')
      }
    })

    // Load the the model values from PPT
    this.loadKeys()
  }

  // Persists the model data into the PPTX Host.
  sync (method, model) {
    console.log('[SYNC] persisting model data to the PPTX host')
    switch (method) {
      case 'read':
        return this.loadKeys()

      case 'create':
      case 'update':
        var object = model.toJSON()
        for (var key in object) {
          const value = object[key]
          this.setKey(key, value)
        }

        return this.saveKeys().fail(function () {
          throw new Error(`Microsoft Office could not ${method} keys`)
        })

      case 'delete':
        for (key of Array.from(model.persistedAttributes)) {
          this.setKey(key, null)
        }

        return this.saveKeys().fail(function () {
          throw new Error(`Microsoft Office could not ${method} keys`)
        })
      default:
        throw new Error(`Invalid sync method: ${method}`)
    }
  }

  // From http://msdn.microsoft.com/en-us/library/office/fp123509.aspx
  // Reads the value of a key from the MS office document.
  getKey (key) {
    return this.document.settings.get(key)
  }

  // Sets the value of a key on a property that's stored
  // in the PPTX document and only accessible from the current
  // frame.
  setKey (key, val) {
    this.document.settings.set(key, val)
  }

  loadKeys () {
    this.model.persistedAttributes.map((key) => {
      return this.model.set(key, this.getKey(key))
    })
  }

  // Save keys to the PPTX Document..
  saveKeys () {
    const d = $.Deferred()
    this.document.settings.saveAsync(function (result) {
      switch (result.status) {
        case 'failed':
          return d.reject(result)
        default:
          return d.resolve()
      }
    })
    return d.promise()
  }

  // Wrap Microsoft's style of handler with a jQuery promise.
  bindOfficeHandler (eventType, opts = {}) {
    this.document.addHandlerAsync(eventType, opts.success, function (
      asyncResult
    ) {
      if (asyncResult.status === 'failed') {
        if (opts.error) {
          opts.error.call(asyncResult)
        }
      }
    })
  }
}
